import React, { useState, useEffect, useContext } from "react";
import AddReturnedProduct from "../components/AddReturnedProduct";
import { can, Permissions } from "../auth/authorization";
import { apiFetch } from "../api/client";
import AuthContext from "../AuthContext";

function ReturnedProduct() {
  const [showReturnedProductModal, setShowReturnedProductModal] =
    useState(false);
  const [returnedProducts, setAllReturnedProductsData] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);
  const [loading, setLoading] = useState(true);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const res = await apiFetch(`/api/returnedProducts/get/${authContext.user}`);
        if (!res.ok) return;
        const data = await res.json().catch(() => null);
        const arr = Array.isArray(data) ? data : (data?.data || data?.Data || []);
        setAllReturnedProductsData(arr || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [updatePage]);

  const getVal = (obj, keys) => {
    for (const k of keys) {
      if (obj == null) break;
      if (Object.prototype.hasOwnProperty.call(obj, k)) return obj[k];
    }
    return undefined;
  };

  const addReturnedProductModalSetting = () => {
    setShowReturnedProductModal(!showReturnedProductModal);
  };

  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        {/* Modal */}
        {showReturnedProductModal && can(Permissions.Add) && (
          <AddReturnedProduct
            addReturnedProductModalSetting={addReturnedProductModalSetting}
            handlePageUpdate={handlePageUpdate}
            authContext={authContext}
          />
        )}

        {/* Table Section */}
        <div className="overflow-x-auto rounded-lg border bg-white border-gray-200">
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 justify-center items-center">
              <span className="font-bold">Returned Product</span>
            </div>
            <div className="flex gap-4">
              {can(Permissions.Add) && (
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 text-xs rounded"
                  onClick={addReturnedProductModalSetting}
                >
                  + Add Returned Product
                </button>
              )}
            </div>
          </div>

          <table className="min-w-full divide-y-2 divide-gray-200 text-sm">
            <thead>
              <tr>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Returned ID
                </th>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Product Name
                </th>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Quantity Returned
                </th>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Reason
                </th>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Returned Date & Time
                </th>
                <th className="whitespace-nowrap px-4 py-2 text-left font-medium text-gray-900">
                  Customer Name
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {returnedProducts.map((product, index) => (
                <tr
                  key={index}
                  className="text-sm text-gray-700 hover:bg-gray-50 transition"
                >
                  <td className="whitespace-nowrap px-4 py-2 text-gray-900">
                    {product.returnedProductId || product.ReturnedProductId || product.returnedId || product.ReturnedId || product.id}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                    {product.productName || product.ProductName || getVal(product, ['product', 'name']) || getVal(product, ['Product', 'Name'])}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                    {product.quantity || product.Quantity || product.quantityReturned || product.QuantityReturned}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                    {product.reason}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                    {new Date(product.returnedAt || product.ReturnedAt || product.returnedDate || product.ReturnedDate || Date.now()).toLocaleString()}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                    {product.customerName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ReturnedProduct;
